module.exports = __webpack_public_path__ + "img/img4.625245d7.jpg";